import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/passport.css";
import App from "@/App";

// Suppress benign ResizeObserver loop error (common with Radix UI)
const RESIZE_MSG = 'ResizeObserver loop completed with undelivered notifications.';
window.addEventListener('error', (e) => {
  if (e.message === RESIZE_MSG) { e.stopImmediatePropagation(); e.preventDefault(); }
}, true);
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message === RESIZE_MSG) { e.stopImmediatePropagation(); e.preventDefault(); }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
